export default "__VITE_ASSET__BBMlxQHW__"